import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function LlmChatToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.LLM_CHAT}>
      {props.children}
    </ToggleWrapper>
  );
}
